var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"light","popper-class":"tsa-custom-tooltipV2","content":_vm.message,"placement":"top"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }